export default "__VITE_ASSET__CwV45A2C__"